<template>
  <button
    v-if="isFavoritingEnabled"
    :class="['favorite-button icon icon--block icon--link-grow fa-heart', {
      'primary': isFavorite,
      'gray': !isFavorite,
      'far': !isFavorite
    }]"
    :disabled="isUpdating"
    tabindex="-1"
    :title="buttonTitle"
    type="button"
    @mousedown.left="toggleFavoriteItem"
  >
    <span class="ada-text">{{ buttonTitle }}</span>
  </button>
</template>


<script>
  import errorHandlers from '@/services/error-handlers';
  import { mapGetters } from 'vuex';

  export default {
    name: 'FavoriteButton',

    inject: {
      validatedForm: {
        default: null,
        from: 'validatedForm'
      }
    },

    props: {
      disableStateUpdate: {
        type: Boolean,
        default: false
      },

      isReceipt: {
        type: Boolean,
        default: false
      },

      item: {
        type: Object,
        required: true
      },

      modifiers: {
        type: Array,
        required: true
      },

      specialInstructions: {
        type: String,
        default: null
      },

      validateForm: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isFavorite: false,
        isUpdating: false
      };
    },

    computed: {
      ...mapGetters('session', ['currentUser', 'orderDetails']),
      ...mapGetters('merchant', ['merchant']),

      isFavoritingEnabled() {
        return this.currentUser.accountId && this.orderDetails.orderType !== 'Catering' && !this.merchant.features['hide-favorites'];
      },

      buttonTitle() {
        if (this.isFavorite) {
          return 'Remove this item from your favorites';
        }

        return 'Add this item to your favorites';
      }
    },

    watch: {
      'item.favoriteItemId': 'favoriteItemIdChangeHandler'
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.isFavorite = !!this.item.favoriteItemId;
      },

      async favoriteItem() {
        try {
          this.isFavorite = true;
          this.isUpdating = true;
          const formIsValid = this.validateForm ? await this.validatedForm.validate() : true;

          if (formIsValid) {
            await this.$store.dispatch('favoriteItems/favoriteItem', {
              disableStateUpdate: this.disableStateUpdate,
              isReceipt: this.isReceipt,
              item: this.item,
              modifiers: this.modifiers,
              specialInstructions: this.specialInstructions
            });

            // this.$triggerGoogleTrackingEvent('FavoriteItem', 'Favorites');

            this.$triggerNewRelicEvent('FavoriteItem', 'Information', 'Favorited Item');
          }

          else {
            this.isFavorite = false;
          }
        }

        catch (error) {
          errorHandlers.generic(error);
          this.isFavorite = false;
        }

        finally {
          this.isUpdating = false;
        }
      },

      favoriteItemIdChangeHandler(newValue) {
        this.isFavorite = !!newValue;
      },

      resetIsFavorite() {
        this.$store.dispatch('menu/unsetSelectedFavoriteItem');
      },

      toggleFavoriteItem() {
        if (this.isFavorite) {
          this.unfavoriteItem();
        }

        else {
          this.favoriteItem();
        }
      },

      async unfavoriteItem() {
        try {
          this.isFavorite = false;
          this.isUpdating = true;

          await this.$store.dispatch('favoriteItems/unfavoriteItem', {
            disableStateUpdate: this.disableStateUpdate,
            isReceipt: this.isReceipt,
            item: this.item
          });
        }

        catch (error) {
          errorHandlers.generic(error);
          this.isFavorite = true;
        }

        finally {
          this.isUpdating = false;
        }
      }
    }
  };
</script>
